import { Location } from 'react-router-dom';
import queryString from 'query-string';
import { lastProduct as getLastProduct } from '~/store/cookies';
import {
	CASINO_GAME_PATHS,
	LIVE_CASINO_GAME_PATHS,
	getCasinoRoutes,
	CASINO_SEARCH_PATHS,
	LIVE_CASINO_SEARCH_PATHS
} from '~/components/router/casino-routes';

/**
 * langCode  'sv'
 * trimming the lang code out of path name
 *
 * @param path '/sv/casino'
 * @returns  '/casino'
 */

function getUrlLangCode() {
	const url = window.location.pathname.split('/');
	return `/${url[1]}`;
}

const defaultLangCode = getUrlLangCode();
function getPath(path: string) {
	const cookieLangCode = getUrlLangCode();
	const langCode = cookieLangCode !== '/' ? cookieLangCode : defaultLangCode;
	return langCode !== '/' && path && (path === langCode || path.startsWith(`${langCode}/`))
		? path.slice(langCode.length)
		: path;
}

export const isCasinoGamePath = (pathname: string) => {
	if (!pathname) return false;
	return [...CASINO_GAME_PATHS, ...LIVE_CASINO_GAME_PATHS].some(path => pathname.includes(path));
};

export const isCasinoSearchPath = (pathname: string) => {
	if (!pathname) return false;
	return [...CASINO_SEARCH_PATHS, ...LIVE_CASINO_SEARCH_PATHS].some(path => pathname.includes(path));
};

export const getExternalRespGamingURL = () => {
	const locale = getUrlLangCode();
	const BASE_URL = window.location.origin;
	return `${BASE_URL}/rg${locale}/responsible-gaming`;
};

export const getBasePathName =
	(license: string, theLastProduct = '') =>
	(): string => {
		if (theLastProduct === 'casino') return getCasinoRoutes(license).ROUTE_CASINO_EXPLORE;
		if (theLastProduct.includes('live-casino')) return getCasinoRoutes(license).ROUTE_LIVE_CASINO;
		return `/${theLastProduct}`;
	};

export const parseQueryString = (location: Location & { query?: string }) => {
	if (location && location.query) {
		return location.query;
	}
	if (location && location.search) {
		return queryString.parse(location.search);
	}
	return false;
};

export const basePathname = (license: string, fallback?: string) => {
	const lastProduct = getLastProduct() as string;
	if (!lastProduct) return getBasePathName(license, fallback)();
	return getBasePathName(license, lastProduct)();
};

export function getRelativePaths(childRoutes: string, parentRoute: string): string;
export function getRelativePaths(childRoutes: string[], parentRoute: string): Record<string, string>;
export function getRelativePaths(childRoutes: string | string[], parentRoute: string): string | Record<string, string> {
	if (!parentRoute || !childRoutes || (Array.isArray(childRoutes) && !childRoutes.length)) {
		return {};
	}
	if (Array.isArray(childRoutes)) {
		const paths: Record<string, string> = {};
		childRoutes.forEach(childRoute => {
			paths[childRoute] = childRoute.split(parentRoute).join('');
		});
		return paths;
	}
	if (typeof childRoutes === 'string') {
		return childRoutes.split(parentRoute).join('');
	}
	return {};
}

export default getPath;
